import PropTypes from "prop-types";

import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, useHistory } from "react-router-dom";

GuestRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
};

function GuestRoute({ component: Component, ...rest }) {
  const [next, setNext] = useState(false);

  const history = useHistory();
  const user = useSelector((state) => state.user);

  useEffect(() => {
    if (user !== null) {
      history.replace("/");
      return;
    }
    setNext(true);
  }, [history, user]);

  return (
    <Route
      {...rest}
      render={() => {
        return next ? <Component /> : <></>;
      }}
    ></Route>
  );
}

export default GuestRoute;
